export default "__VITE_ASSET__CagCjM5w__"